var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoteEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51281 5.65288C8.51281 6.76581 7.61347 7.66515 6.50054 7.66515C5.38761 7.66515 4.48828 6.76581 4.48828 5.65288C4.48828 4.53995 5.38761 3.64062 6.50054 3.64062C7.61347 3.64062 8.51281 4.53995 8.51281 5.65288Z",
    stroke: "#717171",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49999 10.3025C8.48415 10.3025 10.3334 9.13338 11.6206 7.10987C12.1265 6.31733 12.1265 4.98518 11.6206 4.19265C10.3334 2.16914 8.48415 1 6.49999 1C4.51585 1 2.66658 2.16914 1.37941 4.19265C0.873531 4.98518 0.873531 6.31733 1.37941 7.10987C2.66658 9.13338 4.51585 10.3025 6.49999 10.3025Z",
    stroke: "#717171",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteEyeIcon);
export default __webpack_public_path__ + "static/media/noteEyeIcon.def6db1d8e21bd53dad5c13b19e5ee3e.svg";
export { ForwardRef as ReactComponent };